export const iconFontAwesomeMoneyWonSign = (
	<i className="fa-solid fa-won-sign"></i>
);
